var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopPreview"},[_c('form-text-box',{attrs:{"column":_vm.column,"dataList":_vm.dataList,"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }